import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ScGridTable from "../../../components/display/table/gridTableCore";
import FormCore from "../../../components/display/form/formCore";
import monthPickerHoc from "../../../hoc/form/monthPickerHoc";
import { getLockStatusLogList } from "../../../fetch/fetchApi";
import { triggerDownloadFiles } from "@/utils/utils";
// 国际化切换语言

@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class stubStatusLog extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubStatusLog;
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      lockId: this.props.stubIdData.key,
      page: 1,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    const momentFirst = moment(`${moment(new Date()).format("YYYY-MM")}-01`);
    this.formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: ["开始时间", "结束时间"],
          param: {
            name: "date",
            type: "array",
          },
          width: "240px",
          allowClear: false,
          defaultValue: [momentFirst, moment(new Date())],
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            notOverMonth: true,
          },
          labelName: "起止日期",
          required: !0,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search'
            },
            {
              btnType: "button",
              text: this.internationalization.btn2, // '导出',
              icon: "export",
              handler: (e, param) => {
                this.exportData(param);
              },
            },
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        lockId: this.query.lockId,
        startTime: `${moment(new Date()).format("YYYY-MM")}-01 00:00:00`,
        endTime: `${moment(new Date()).format("YYYY-MM-DD")} 23:59:59`,
      },
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "moduleStatusLog",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: this.internationalization.title2, // '上报时间',
            key: "createTime",
            align: "center",
          },
          {
            name: "状态码",
            key: "status",
            colType: "tipCol",
            tipNum: 15,
          },
          {
            name: this.internationalization.title4, // 状态信息',
            key: "statusCn",
            colType: "tipCol",
            tipNum: 15,
          },
        ],
        tableChange: () => {},
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getLockStatusLogList,
        tableKey: "moduleStatusLog",
      },
    });
  }

  fetchApi = (params) => {
    let result = {
      ...params,
    };
    const date = params.date.split(",");
    if (params.date) {
      result = {
        ...result,
        startTime: `${moment(date[0]).format("YYYY-MM-DD")} 00:00:00`,
        endTime: `${moment(date[1]).format("YYYY-MM-DD")} 23:59:59`,
        lockId: this.props.stubIdData.key,
      };
    }
    delete result.date;
    return result;
  };

  // 调用接口导出数据
  async exportData(param) {
    const date = param.date.split(",");
    param.startTime = `${moment(date[0]).format("YYYY-MM-DD")} 00:00:00`;
    param.endTime = `${moment(date[1]).format("YYYY-MM-DD")} 23:59:59`;
    delete param.date;
    await triggerDownloadFiles(
      "mtsV2/stub/locklog/export",
      {
        ...param,
      },
      `地锁状态日志${date[0]}~${date[1]}`,
      "xlsx",
      "post",
    );
  }

  render() {
    return (
      <div className="sc-page-content">
        <FormCore
          formConfig={this.formConfig}
          getInstance={this.props.getInstance}
          fetchApi={this.fetchApi}
        />
        <div className="page-panel no-table-footer" style={{ marginTop: 15 }}>
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>
      </div>
    );
  }
}

export default injectIntl(stubStatusLog);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/lockStatusLog.js